import { useEffect, useState } from "react";
import { clientAPI } from "@/lib/api";

const formatEur = (v) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

/** En tête de l'onglet Facture de la fiche client : facturé, encaissé, reste dû (calcul serveur, un appel). */
export const ClientInvoiceTotals = ({ clientId, refreshKey }) => {
  const [t, setT] = useState(null);
  useEffect(() => {
    clientAPI.invoiceTotals(clientId).then(r => setT(r.data)).catch(() => setT(null));
  }, [clientId, refreshKey]);
  if (!t) return null;
  const items = [
    { key: "billed", label: "Facturé", value: t.billed_ttc, cls: "text-slate-900" },
    { key: "paid", label: "Encaissé", value: t.paid_ttc, cls: "text-emerald-600" },
    { key: "remaining", label: "Reste dû", value: t.remaining_ttc, cls: t.remaining_ttc > 0.009 ? "text-amber-600" : "text-emerald-600" },
  ];
  return (
    <div className="grid grid-cols-3 gap-3 mb-4" data-testid="client-invoice-totals">
      {items.map(i => (
        <div key={i.key} className="rounded-lg border border-slate-200 bg-slate-50/60 px-3 py-2">
          <div className="text-[11px] uppercase tracking-wide text-slate-500">{i.label}</div>
          <div className={`text-base font-semibold tabular-nums ${i.cls}`} data-testid={`client-invoice-total-${i.key}`}>{formatEur(i.value)}</div>
        </div>
      ))}
    </div>
  );
};
